import React, { useContext } from 'react';
import { CartContext } from "components/cart";
import classNames from 'lib/classNames';

export default function GiftWithPurchaseWidget ({ giftGoal, multi_goal_type, filteredItems }) {
    const {
        get_total,
        Utils,
        campaigns,
        cart_settings: {
            rtl,
            money_format,
            product
        },
        shopify_cart_items,
        giftCurrentPreview,
        isPreview,
        productAddedToCart
    } = useContext(CartContext);
    const bundlesDiscounts = Utils.getDiscount({ campaigns, items: shopify_cart_items, getBundlesOnly: true });
    const { original } = get_total(null, filteredItems);
    const { gift, goal } = giftGoal
    const { widget } = gift
    const formattedGoal = parseInt(goal * 100)
    const amount = original - bundlesDiscounts
    const rate = parseFloat(window.Shopify.currency.rate)
    const replacedAmountValue = (formattedGoal * rate) - amount
    const current = isPreview ? giftCurrentPreview : productAddedToCart(gift.product) || (replacedAmountValue <= 0 && multi_goal_type === "amount") ? "after" : "before"
    return <div className={classNames("rounded border mb-6")} style={{
        background: Utils.formatColor(widget[current].background),
        borderColor: Utils.formatColor(widget[current].outline)
    }}>
        <div className={classNames("text-center p-2 border-b")} style={{
            borderColor: Utils.formatColor(widget[current].outline)
        }} dangerouslySetInnerHTML={{ __html: formatHeader({ text: widget[current].header, goal, replacedAmountValue, multi_goal_type, formatMoney: (v, f) => Utils.formatMoney(v, money_format, f), filteredItems }) }} />
        <div>
            <div className={classNames("flex p-2")}>
                <div
                    className={classNames("bg-cover bg-center block relative", {
                        "ml-2": rtl,
                        "mr-2": !rtl
                    })}
                    style={{
                        backgroundImage: `url(${gift.product.image})`,
                        width: `${product.image_size}px`,
                        height: `${product.image_size}px`
                    }}
                >
                    {
                        current === "after" && <div className={classNames("w-4 h-4 rounded-full absolute flex-center text-white top-3px transform -translate-y-1/2", {
                            "left-3px -translate-x-1/2": rtl,
                            "right-3px translate-x-1/2": !rtl,
                        })} style={{
                            background: Utils.formatColor(widget.after.offer_highlight.color)
                        }}>
                            <svg className={classNames("w-3 h-3")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                        </div>
                    }
                </div>
                <Widget gift={gift} current={gift.widget[current]} />
            </div>
        </div>
    </div>
}

function formatProductName (text, product_name) {
    return text
        .replace(
            "{{product_name}}",
            product_name
        )
}
function formatCompareAtPrice (text, price) {
    return text
        .replace(
            "{{compare_at_price}}",
            `<del>${price}</del>`
        )
}

function formatHeader ({ text, goal, replacedAmountValue, multi_goal_type, formatMoney, filteredItems }) {
    const replacedAmount = replacedAmountValue > 0 ? formatMoney(replacedAmountValue) : formatMoney("x.xx", v => v);
    const replacedQuantity =
        goal -
        filteredItems
            .map((item) => item.quantity)
            .reduce((acc, item) => acc + item, 0);
    return text
        .replace(
            "{{amount_left}}",
            multi_goal_type === "quantity" ? replacedQuantity : replacedAmount
        )
        .replace("{{goal}}", formatMoney(goal * 100));
}

function Widget ({ gift, current }) {
    const { widget, product } = gift
    const { cart_settings: { money_format }, Utils, rtl } = useContext(CartContext);

    return (
        <div className={classNames("flex-1 flex-col")} >
            <div
                className={classNames("mb-2 overflow-hidden line-clamp")}
            >
                <span
                    dangerouslySetInnerHTML={{
                        __html: formatProductName(current.product_name, product.title)
                    }}
                />
            </div>
            <div>

                {widget.compare_at_price_active && <b className={classNames(rtl ? "ml-2" : "mr-2")}
                    style={{
                        fontSize: Utils.em(widget.compare_at_price.font_size),
                        fontWeight: widget.compare_at_price.font_weight,
                        color: Utils.formatColor(widget.compare_at_price.color)
                    }}
                    dangerouslySetInnerHTML={{
                        __html: formatCompareAtPrice(widget.compare_at_price.text, Utils.formatMoney(gift.product.variant_price, money_format))
                    }} />}
                <b
                    className={classNames("flex-1")}
                    style={{
                        fontSize: Utils.em(current.offer_highlight.font_size),
                        fontWeight: current.offer_highlight.font_weight,
                        color: Utils.formatColor(current.offer_highlight.color)
                    }}>{current.offer_highlight.text}</b>
            </div>
        </div>
    )
}